<!--jfEvent 局放事件-->
<template>
  <div class="myelEventBody">
    <div class="con">
      <div class="search-input-btn" style="width:100%">
        <div class="input-small myinput">
          <span>时间：</span>
          <el-date-picker v-model="form.dataTime" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>

        <el-button type="primary" @click="searchEvents" class="search-btn">查询</el-button>
      </div>

      <div class="elEvent_bottom" :style="{'height':tabHeights+'px'}">
        <el-table :data="eventList" style="width: 100%" border :height="tabHeights - 20">
          <el-table-column label="序号" width="60" align="center">
            <template slot="empty">
              <span class="noData">
                <img src="@/assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="linkobject" label="关联对象" width="200">
          </el-table-column>

          <el-table-column label="等级" width="85" align="center">
            <template #default="{row}">
              <div class="public-flex">
                <p class="myemergent mutongyong" v-if="row.eventlevel =='0'">消息</p>
                <p class="myhigh mutongyong" v-if="row.eventlevel =='1'">预警</p>
                <p class="mystandard mutongyong" v-if="row.eventlevel =='2'">告警</p>
                <p class="mylow mutongyong" v-if="row.eventlevel =='3'">通知</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="typeName" label="事件类型" width="115" align="center">
          </el-table-column>
          <el-table-column prop="time" label="时间" width="165" :formatter="formatTime">
          </el-table-column>
          <el-table-column prop="description" label="内容" min-width="320">
          </el-table-column>

          <el-table-column label="状态" width="105" align="center">
            <template #default="{row}">
              <div class="patrol public-flex" v-if="row.eventstate ==2">
                <p></p><span>已处理</span>
              </div>
              <div class="patrol public-flex" v-else-if="row.eventstate ==3">
                <p></p><span>已确认</span>
              </div>
              <div class="overhaul public-flex" v-else>
                <p></p><span>未处理</span>
              </div>

            </template>
          </el-table-column>
          <el-table-column label="PRPS图诺" width="90" align="center">
            <template #default="{row}">
              <el-button type="text" size="mini" @click="submit(row)" style="color:#368ED9">查看</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="confirmuser" label="确认人" width="100">
          </el-table-column>
          <el-table-column prop="confirmtime" width="165" label="确认时间" :formatter="formatTimeConfirm">
          </el-table-column>
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="confirmEvent(scope.row)" style="color:#368ED9">确认事件</el-button>
            </template>
          </el-table-column>
        </el-table>

      </div>
      <div class="divider-line"></div>
      <div class="paging">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
          :current-page="currentPage" :page-sizes="[15, 25, 35, 45, 55]" :page-size="15"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>

    <el-dialog title="PRPS图谱" :close-on-click-modal='false' v-dialogDrag :visible.sync="dialogVisible" width="800px"
      center>
      <div id="proportion" style="width: 700px;"></div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </template>
    </el-dialog>

  </div>
</template>

<script>
  import request from "@/api/http.js";
  import * as echarts from 'echarts';
  import "echarts-gl"
  export default {
    data () {
      return {
        dialogVisible: false,
        tabHeights: Math.round((document.getElementById('app').clientHeight)*0.76),
        form: {
          eventType: 20,
          dataTime: [new Date(),new Date()],
        },
        eventList: [
          {
            "no": 30,
            "type": 20,
            "linkobject": "局放主机.第一通道故障预警等级",
            "confirmtime": 1713498506000,
            "confirmuser": null,
            "time": 1712821279000,
            "eventstate": 2,
            "eventlevel": 0,
            "description": "局放设备：1#高频局放恢复正常",
            "linkdevice": -2,
            "typeName": "局部放电",
            "limitedColor": null
          },
          {
            "no": 29,
            "type": 20,
            "linkobject": "局放主机.第二通道故障预警等级",
            "confirmtime": 1713424152000,
            "confirmuser": "1",
            "time": 1712816351000,
            "eventstate": 3,
            "eventlevel": 0,
            "description": "局放设备：2#高频局放恢复正常",
            "linkdevice": -3,
            "typeName": "局部放电",
            "limitedColor": null
          },
          {
            "no": 16,
            "type": 20,
            "linkobject": "devicestate.局放主机",
            "confirmtime": 1713407222000,
            "confirmuser": "2",
            "time": 1712473173000,
            "eventstate": 2,
            "eventlevel": 0,
            "description": "数据采集通道`设备串口局放` 局放主机 通讯中断",
            "linkdevice": -2,
            "typeName": "局部放电",
            "limitedColor": null
          },
          {
            "no": 14,
            "type": 20,
            "linkobject": "设备串口局放",
            "confirmtime": 1713151261000,
            "confirmuser": "",
            "time": 1712473172000,
            "eventstate": 2,
            "eventlevel": 0,
            "description": "通道`设备串口局放`中断",
            "linkdevice": -2,
            "typeName": "局部放电",
            "limitedColor": null
          },
          {
            "no": 13,
            "type": 20,
            "linkobject": "devicestate.局放主机",
            "confirmtime": 1713256667000,
            "confirmuser": null,
            "time": 1712125854000,
            "eventstate": 2,
            "eventlevel": 0,
            "description": "数据采集通道`设备串口局放` 局放主机 通讯恢复",
            "linkdevice": -2,
            "typeName": "局部放电",
            "limitedColor": null
          },
          {
            "no": 12,
            "type": 20,
            "linkobject": "设备串口局放",
            "confirmtime": 1712974300000,
            "confirmuser": "1",
            "time": 1712125835000,
            "eventstate": 2,
            "eventlevel": 0,
            "description": "通道`设备串口局放`恢复",
            "linkdevice": -2,
            "typeName": "局部放电",
            "limitedColor": null
          },
          {
            "no": 3,
            "type": 20,
            "linkobject": "devicestate.局放主机",
            "confirmtime": null,
            "confirmuser": "",
            "time": 1712111145000,
            "eventstate": 0,
            "eventlevel": 0,
            "description": "数据采集通道`设备串口局放` 局放主机 通讯中断",
            "linkdevice": -2,
            "typeName": "局部放电",
            "limitedColor": null
          },
          {
            "no": 1,
            "type": 20,
            "linkobject": "设备串口局放",
            "confirmtime": null,
            "confirmuser": "",
            "time": 1712111144000,
            "eventstate": 0,
            "eventlevel": 0,
            "description": "通道`设备串口局放`中断",
            "linkdevice": -2,
            "typeName": "局部放电",
            "limitedColor": null
          }
        ],
        state: -1,
        currentPage: 1,
        currentSize: 20,
        total: 0,
        loading: false,
      }
    },

    mounted () {
      debugPage=this
      //默认全选 
      this.searchEvents()
    },

    computed: {
      eventStore () {
        return this.$store.eventStore
      },
      getEventTypes () {
        return this.eventStore.getters.searchAllEventTypes
      },
      nowUnit () {
        return this.$store.unitStore.getters.getNowUnit
      },
      getLevelName () {
        return this.$store.eventStore.getters.getLevelName
      },
      getStateName () {
        return this.$store.eventStore.getters.getStateName
      },
    },
    watch: {
      eventList (nv,ov) {
        console.log("数据",nv);
      }
    },
    methods: {
      submit (v) {
        console.log(111);
        this.form={
          "malfunctionLv": "0",
          "samplingAverage": "-65",
          "samplingTop": "-79",
          "topPhase": "202.5",
          "pulseNum": "0",
          "atlas": "0 3 6 9 12 15 18 21 24 23 26 29 32 35 38 37 40 43 46 49 52 54 57 60 61 62 63 64 64 64 63 64 64 63 62 61 60 58 56 55 50 45 40 35 30 25 20 15 10 2 16 24 34 32 30 28 26 30 34 38 40 40 30 20 9",
          "deviceType": "地电波"
        };

        var d=this.form.atlas.split(' ');//数据

        var result=[];
        for(var i=0;i<d.length;i+=64) {
          result.push(d.slice(i,i+64));
        };
        console.log(result,22);
        this.aaa(result)

        // request({url: "/partial/psprByNo",method: "get",params}).then(res => {
        //   if(res.code==200) {

        //   }
        // })
      },
      aaa (v) {
        if(!v) {
          this.$message({showClose: true,message: '没有数据',type: 'info'});
          return
        };

        var listData=[]
        v.map((a,i) => {
          var d=a;//数据
          d.map((b,ii) => {
            listData.unshift([i,ii,b])
          })
        })




        this.dialogVisible=true;


        var hours=Array.from({length: 65},(_,i) => i);

        var days=Array.from({length: 50},(_,i) => i);
        var option={
          tooltip: {},
          visualMap: {
            max: 64,
            inRange: {
              color: [
                '#7db645',
                '#3f897a',
                '#4c4f8e',
                '#867b90',
                '#f0e03f',
                '#e23e35',
                '#c57198'
              ]
            }
          },
          xAxis3D: {
            name: '相位(°)',
            type: 'category',
            data: hours,
            axisLabel: {
              // 设置刻度为每5个递进
              showMaxLabel: true,
              interval: 16,
              formatter: (value,index) => {
                // 1小时=3600秒
                var d={
                  '8': 45,
                  '16': 90,
                  '24': 135,
                  '32': 180,
                  '40': 225,
                  '48': 270,
                  '56': 315,
                  '64': 360,
                }
                return d[value];
              },
            }
          },
          yAxis3D: {
            name: '周期',
            type: 'category',
            data: days,
            axisLabel: {
              showMaxLabel: true,
              // 设置刻度为每5个递进
              interval: 4
            }
          },
          zAxis3D: {
            name: '相对幅值(V)',
            type: 'value'
          },
          grid3D: {
            boxWidth: 300,
            boxDepth: 200,
            viewControl: {
              projection: 'perspective', // 先设置为这个perspective
              distance: 320,
              // 设置视角的上下旋转角度，取值范围为 -90 ~ 90
              beta: 47,
              // 设置视角的左右旋转角度，取值范围为 -180 ~ 180
              alpha: 5
            },
          },
          series: [
            {
              type: 'bar3D',
              data: listData.map(function(item) {
                return {
                  value: [item[1],item[0],item[2]]
                };
              }),
              shading: 'color',
              label: {
                show: false,
                fontSize: 16,
                borderWidth: 1
              },
              itemStyle: {
                opacity: 0.4
              },
              emphasis: {
                label: {
                  fontSize: 20,
                  color: '#900'
                },
                itemStyle: {
                  color: '#900'
                }
              }
            }
          ]
        };

        setTimeout(() => {
          var proportion=echarts.init(document.getElementById("proportion"));

          proportion.setOption(option,true);
        },300);
      },

      formatEventLevel (row,column,cellValue) {
        return this.getLevelName(row.eventlevel)
      },
      formatterEventState (row,column,cellValue) {
        return this.getStateName(row.eventstate)
      },
      formatTime (row,column,cellValue) {
        return new Date(row.time).format('yyyy/MM/dd hh:mm:ss')
      },
      formatTimeConfirm (row,column,cellValue) {
        if(!isempty(row.confirmtime)) {
          return new Date(row.confirmtime).format('yyyy/MM/dd hh:mm:ss')
        }
      },
      selectAll () {
        if(this.form.eventType[0]=="全选") {
          this.getEventTypes.forEach(item => {
            this.form.eventType.push(item.no)
          })
        } else {
          this.form.eventType=[]
        }
      },
      //分页功能 
      handleSizeChange (val) {
        this.currentSize=val;
        this.searchEvents()
      },
      handleCurrentChange (val) {
        this.currentPage=val;
        this.searchEvents()
      },
      confirmEvent (row) {
        //确认事件
        this.$api.eventApi.confirmEventByEventNo(row.no,respon => {
          this.$message.success("确认成功")
          this.searchEvents()
        },respon => {
          this.$message.warning("确认失败")
        })
      },
      searchEvents () {
        //查询事件


        //bgTime变成0点0秒
        let y=this.form.dataTime[0].getFullYear();
        let m=this.form.dataTime[0].getMonth();
        let d=this.form.dataTime[0].getDate();
        let bgTime=new Date(y,m,d).getTime();
        //let bgTime = this.form.dataTime[0].getTime()
        //把0点0分变成23点59
        let endTime=this.form.dataTime[1].getTime()+60*60*24*1000-1

        this.loading=true
        this.$api.eventApi.searchEventListByUser(undefined,this.nowUnit.id,this.form.eventType,this.state,-1,getValueIfNoNull(this.nowDevice,{}).no,bgTime,endTime,this.currentPage,this.currentSize,'',respon => {
          this.total=respon.total
          this.eventList=respon.data
          this.loading=false
        })
      },
    }
  }
</script>

<style scoped lang='scss'>
  #proportion {
    height: 500px;
    width: 100%;
  }

  .myelEventBody {
    .con {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      background-color: #fff;
      padding: 2px 20px 20px 20px;

    }

    .paging {
      display: flex;
      justify-content: flex-end;
      margin-top: 10px;
    }

    .public-flex {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    // 巡检
    .patrol {
      p {
        width: 8px;
        height: 8px;
        background-color: #0DAE88;
        border-radius: 50%;
        margin-right: 8px;
        position: relative;
        top: -1px;
      }

      span {
        color: #0DAE88;
      }
    }

    // 检修
    .overhaul {
      p {
        width: 8px;
        height: 8px;
        background-color: #FF1D1D;
        border-radius: 50%;
        margin-right: 8px;
      }

      span {
        color: #FF1D1D;
      }
    }

    .mutongyong {
      width: 36px;
      height: 20px;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 2px;
    }

    //消息
    .myemergent {
      border: 1px solid #2981D2;
      color: #2981D2;
      background-color: #DEF3FF;
    }

    //预警
    .myhigh {
      border: 1px solid #FF7C1D;
      color: #FF7C1D;
      background-color: #FFF1E7;
    }

    //告警
    .mystandard {
      border: 1px solid #ED6547;
      color: #ED6547;
      background-color: #FFECEC;
    }

    //通知
    .mylow {
      border: 1px solid #0DAE88;
      color: #0DAE88;
      background-color: #8EF9DF;
    }
  }
</style>